import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Box } from '@mui/material';
import { AgentMarketPlaceItemWithFilter } from './AgentMarketPlace';

// Video-only renderer component
const renderVideo = (videoUrl: string) => {
  if (!videoUrl) {
    return (
      <Box sx={{ mt: 2, textAlign: 'center', py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          No demo video available for this agent.
        </Typography>
      </Box>
    );
  }

  // Embed any URL in an iframe (works for Wistia, YouTube, Vimeo, etc.)
  return (
    <Box sx={{ mt: 1, position: 'relative', paddingTop: '56.25%' /* 16:9 aspect ratio */ }}>
      <iframe
        src={videoUrl}
        title="Demo video player"
        allow="autoplay; fullscreen"
        allowFullScreen
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 0,
        }}
      />
    </Box>
  );
};

interface AgentDemoVideoDialogProps {
  onClose: () => void;
  agent: AgentMarketPlaceItemWithFilter | null;
}

const AgentDemoVideoDialog: React.FC<AgentDemoVideoDialogProps> = ({ onClose, agent }) => {
  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle>
        <Typography variant="h6" component="div">
          {agent ? `${agent.name} - Demo Video` : 'Demo Video'}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {agent && agent.demo_video_url ? (
          renderVideo(agent.demo_video_url)
        ) : (
          <Box sx={{ mt: 2, textAlign: 'center', py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              No demo content available for this agent.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgentDemoVideoDialog;
